import { FetchContext } from 'context/FetchContext';
import { useContext } from 'react';
import { useMutation, useQueryClient } from 'react-query';

function useManageTopicStory({ topicID, axiosConfigs = {} }) {
  const fetchContext = useContext(FetchContext);
  const { privateFetch } = fetchContext;
  const queryClient = useQueryClient();

  function addTopicStory(data = {}) {
    return privateFetch.post(`/v1/admin/topic/${topicID}/story`, data?.data ?? {}, axiosConfigs);
  }

  function updateTopicStory({ data } = {}) {
    const { id: storyID, ...rest } = data ?? {};
    return privateFetch.put(`/v1/admin/topic/${topicID}/story/${storyID}`, rest, axiosConfigs);
  }

  function deleteTopicStory({ storyID } = {}) {
    return privateFetch.delete(`/v1/admin/topic/${topicID}/story/${storyID}`, axiosConfigs);
  }

  function reOrderTopicStory(data = {}) {
    return privateFetch.patch(`/v1/admin/content/story/reorder`, data, axiosConfigs);
  }

  function manageTopicsSections({ type, ...data } = {}) {
    if (type === 'UPDATE') {
      return updateTopicStory(data);
    }

    if (type === 'DELETE') {
      return deleteTopicStory(data);
    }

    if (type === 'REORDER') {
      return reOrderTopicStory(data);
    }

    return addTopicStory(data);
  }

  return useMutation(manageTopicsSections, {
    onSuccess() {},
    onError() {},
    onSettled() {
      queryClient.invalidateQueries('topic-details');
    },
  });
}

export default useManageTopicStory;
